module.exports = __webpack_public_path__ + "img/ic_32_stepper_up.0d28c717.svg";